import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import MoreIcon from '../../../BaseComponents/Icons/MoreIcon'
import { PreEventProps } from '../EventTypes'
import LabelFont from '../../../Theme/Fonts/Label'
import HighlightRow from '../../HighlightRow'

const PreEventRow: FC<Omit<PreEventProps, 'type'>> = ({
    onPressEvent,
    onPressMore,
    eventStartTime,
    caption,
    paddingTop = 5,
    borderRadius,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText,
}) => {
    return (
        <Grid
            paddingX={11}
            paddingTop={paddingTop}
            paddingBottom={4}
            backgroundColor="pearl"
            noExpand
            horizontal
            borderRadius={borderRadius}
        >
            <Grid>
                <Touchable onPress={onPressEvent}>
                    <Grid noExpand width="100%" center>
                        <Grid
                            centerVertical
                            noExpand
                            horizontal
                            paddingX={2}
                            height={20}
                            borderRadius={1}
                        >
                            <LabelFont color="onyx">{eventStartTime}</LabelFont>
                        </Grid>
                        {caption ? (
                            <Grid marginTop={2}>
                                <LabelFont color="keshi-3">{caption}</LabelFont>
                            </Grid>
                        ) : null}
                    </Grid>
                </Touchable>
                {onPressVideoButton || videoButtonHref ? (
                    <HighlightRow
                        text={videoButtonText}
                        onPress={onPressVideoButton}
                        href={videoButtonHref}
                        marginTop={3}
                    />
                ) : null}
            </Grid>

            <Grid noExpand>
                <Touchable onPress={onPressMore}>
                    <MoreIcon />
                </Touchable>
            </Grid>
        </Grid>
    )
}

export default PreEventRow
